/*
 * countdown-banner.js — performance-fixed version
 *
 * Same markup, same data attributes, same look. The only change:
 * the original redrew the timer on every animation frame (~60x per second,
 * forever), rewriting four text nodes and the element's display style each
 * time. This version ticks once per second, only touches the DOM when a value
 * actually changes, pauses while the tab is hidden, and stops completely once
 * the countdown ends.
 */
if (!customElements.get("countdown-timer")) {
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();
      const timezone = this.dataset.timezone;
      const date = this.dataset.date.split("-");
      const day = parseInt(date[0]);
      const month = parseInt(date[1]);
      const year = parseInt(date[2]);
      let time = this.dataset.time;
      let tarhour = 0;
      let tarmin = 0;
      if (time) [tarhour, tarmin] = time.split(":").map(Number);
      const date_string =
        month + "/" + day + "/" + year + " " + tarhour + ":" + tarmin + " GMT" + timezone;
      this.countDownDate = new Date(year, month - 1, day, tarhour, tarmin, 0, 0).getTime();
      this.countDownDate = new Date(date_string).getTime();
      this._timer = null;
      this._last = {};
      this._display = null;
    }

    convertDateForIos(date) {
      var arr = date.split(/[- :]/);
      date = new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4], arr[5]);
      return date;
    }

    connectedCallback() {
      this._els = {
        days: this.querySelector(".days .countdown-timer--column--number"),
        hours: this.querySelector(".hours .countdown-timer--column--number"),
        minutes: this.querySelector(".minutes .countdown-timer--column--number"),
        seconds: this.querySelector(".seconds .countdown-timer--column--number"),
      };
      this._onVisibility = () => {
        if (document.hidden) this._stop();
        else this._start();
      };
      document.addEventListener("visibilitychange", this._onVisibility);
      this._start();
    }

    disconnectedCallback() {
      this._stop();
      document.removeEventListener("visibilitychange", this._onVisibility);
    }

    _start() {
      if (this._timer) return;
      if (this._tick() === false) return;
      // Align ticks to the start of each second so the display stays accurate.
      const align = 1000 - (Date.now() % 1000);
      this._timer = setTimeout(() => {
        if (this._tick() === false) return;
        this._timer = setInterval(() => this._tick(), 1000);
      }, align);
    }

    _stop() {
      if (this._timer) {
        clearTimeout(this._timer);
        clearInterval(this._timer);
        this._timer = null;
      }
    }

    _setDisplay(value) {
      if (this._display !== value) {
        this.style.display = value;
        this._display = value;
      }
    }

    _set(key, value) {
      const el = this._els[key];
      if (el && this._last[key] !== value) {
        el.textContent = value;
        this._last[key] = value;
      }
    }

    _tick() {
      const distance = this.countDownDate - Date.now();
      if (distance < 0 || isNaN(distance)) {
        this._setDisplay("none");
        this._stop();
        return false;
      }
      this._setDisplay("flex");
      const days = Math.floor(distance / (1e3 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1e3 * 60 * 60 * 24)) / (1e3 * 60 * 60));
      const minutes = Math.floor((distance % (1e3 * 60 * 60)) / (1e3 * 60));
      const seconds = Math.floor((distance % (1e3 * 60)) / 1e3);
      this._set("days", CountdownTimer.addZero(days));
      this._set("hours", CountdownTimer.addZero(hours));
      this._set("minutes", CountdownTimer.addZero(minutes));
      this._set("seconds", CountdownTimer.addZero(seconds));
      return true;
    }

    static addZero(x) {
      return x < 10 && x >= 0 ? "0" + x : x;
    }
  }
  customElements.define("countdown-timer", CountdownTimer);
}
